<template>
   <audioList :videoList="Mydata.videoList"></audioList>
</template>

<script>
  import audioList from '@/components/audio/audiolist'
    export default {
        name: "tabspeaker",
      components:{
        audioList
      },
      props:{
        Mydata:Object
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/tabspeaker.vue